import { render, staticRenderFns } from "./EditTindakanClosing.vue?vue&type=template&id=3f16fb9e&lang=pug&"
import script from "./EditTindakanClosing.vue?vue&type=script&lang=js&"
export * from "./EditTindakanClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports